module.exports = __webpack_public_path__ + "img/sass.ce869667.png";